import { render, staticRenderFns } from "./EditSubscription.vue?vue&type=template&id=10402f83&"
import script from "./EditSubscription.vue?vue&type=script&lang=js&"
export * from "./EditSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports